import { Component, HostListener, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { OpsInputComponent } from '../ops-input/ops-input.component';
import { UsersService } from '@ops/shared-types';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'ops-forgot-password',
  standalone: true,
  imports: [CommonModule, TranslateModule, OpsInputComponent],
  templateUrl: './ops-forgot-password.component.html',
  styleUrl: './ops-forgot-password.component.scss',
})
export class OpsForgotPasswordComponent implements OnDestroy {
  email: string;
  errorsTrack = {};
  subscriptions: Array<Subscription> = [];
  resetLinkSent = false;
  constructor(private userService: UsersService, private router: Router, private translateService: TranslateService) {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  @HostListener('document:keydown', ['$event']) onKeyDown(e: any) {
    if (e.key === 'Enter') {
      setTimeout(() => {
        this.resetPassword();
      }, 100);
      return;
    }
  }

  onInputEmail(event: any) {
    this.email = event || '';
  }

  onErrorHandler(error: string, field?: string) {
    if (!error || error === '') {
      delete this.errorsTrack[field];
    } else {
      this.errorsTrack[field] = error;
    }
  }

  get isDisabled(): boolean {
    if (this.email && Object.keys(this.errorsTrack).length === 0) {
      return false;
    }

    return true;
  }

  resetPassword() {
    const sub = this.userService.forgotPassword(this.email).subscribe({
      next: (resp) => {
        // console.log('RESP', resp);
        // this.router.navigate(['/login']);
        this.resetLinkSent = true;
      },
      error: (e) => {
        if (e?.error) {
          const error = JSON.parse(e.error);
          window.alert(this.translateService.instant('windowAlert.generic.error', { error: error['message'] }));
        } else {
          window.alert(this.translateService.instant('windowAlert.opsForgotPassword.somethingWentWrong'));
        }
      },
    });
    this.subscriptions.push(sub);
  }
}
